<template>
    <div class="absence" :style="$options.getStyle(absence, currentZoom)">
        <i class="absence-icon" :class="$options.getIconClass(absence)"></i>
    </div>
</template>

<script>
export default {
    props: {
        absence: {
            required: true,
            type: Object,
            default() {
                return {};
            },
        },
        currentZoom: {
            required: true,
            type: Number,
        },
    },
    getStyle(absence, currentZoom) {
        if (currentZoom !== 0) {
            return {
                background: absence.color,
                top: absence.posStart + '%',
                height: absence.relativeHeight + '%',
            };
        }

        return {
            background: absence.color,
            marginLeft: absence.posStart + 'px',
            height: '100%',
            width: absence.width + 'px',
            zIndex: 1,
        };
    },
    getIconClass(absence) {
        switch (absence.icon) {
            case 1:
                return 'icofont-home';
            case 2:
                return 'icofont-airplane-alt';
            case 3:
                return 'icofont-medical-sign';
            case 4:
                return 'icofont-rainy';
            case 5:
                return 'icofont-hat-alt';
        }
        return '';
    },
};
</script>

<style lang="scss">
.absence {
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.9;
}
.absence-icon {
    color: #fff;
    font-size: 15px;
}
</style>
